// Selectors
import { selectEntityTypesArray } from '../../services/entityTypes/selectors';

// Utils
import orderBy from '../../utils/custom-orderBy';
import createDeepEqualSelector from '../../utils/reselect/createDeepEqualSelector';

interface Props {
    includeDeleted?: boolean;
}

const selectIncludeDeleted = (state: *, props: Props) => props.includeDeleted;

const selectFilteredData = createDeepEqualSelector(
    [selectEntityTypesArray, selectIncludeDeleted],
    (entityTypesArrayState, includeDeletedProp) => {
        if (includeDeletedProp) return entityTypesArrayState;
        return entityTypesArrayState.filter(value => !value.deletedAt);
    }
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'depth')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState =>
        orderedDataState &&
        orderedDataState.map(({ id, name }) => ({
            key: id,
            text: name,
            value: id
        }))
);

export { selectOrderedData, selectOptions };
